import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const aiSpellingGrammarPluginKey = new PluginKey('aiSpellingGrammarPlugin');
